module.exports = __webpack_public_path__ + "img/project_treasurehunt.61989ad9.png";